export const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT || 'http://localhost:8000/v1';
export const REACT_APP_FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || '';
export const PORT = process.env.PORT || '8001';
